export default "__VITE_ASSET__B1BTI0re__"